import React from 'react';
import { FileText, Mail } from 'lucide-react';
import CircuitCanvas from './CircuitCanvas';
import MeshWaveCanvas from './MeshWaveCanvas';
import TypingTagline from './TypingTagline';

const backgrounds = [CircuitCanvas, MeshWaveCanvas] as const;
const SelectedBackground = backgrounds[Math.floor(Math.random() * backgrounds.length)];

const Hero: React.FC = () => {
  return (
    <section id="hero" className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      <SelectedBackground />

      <div className="relative z-10 text-center px-4">
        <h1 className="text-5xl md:text-7xl font-display font-bold mb-4 neon-text tracking-tight text-white">
          Brandon Ellis
        </h1>
        <h2 className="text-lg md:text-xl font-display font-medium tracking-wide text-accent/80 mb-6">
          Senior Software Engineer
        </h2>
        <TypingTagline />

        <div className="flex gap-4 justify-center">
          <a
            href="https://d204t2bnuk7ee7.cloudfront.net/assets/documents/Brandon_Ellis_Resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 px-6 py-3 bg-white/5 border border-white/20 rounded-md text-gray-300 text-sm font-medium transition-all duration-200 hover:bg-white/10 hover:border-white/40 hover:text-white"
          >
            <FileText size={16} />
            Resume
          </a>
          <a
            href="#contact"
            className="group flex items-center gap-2 px-6 py-3 bg-accent/10 border border-accent/40 rounded-md text-accent text-sm font-medium transition-all duration-200 hover:bg-accent/20 hover:border-accent/70"
          >
            <Mail size={16} />
            Contact
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-accent/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-accent rounded-full mt-2 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
